
export const FETCH_NOTIFICATION_FAILURE = 'FETCH_NOTIFICATION_FAILURE';
export const FETCH_NOTIFICATION_REQUEST = 'FETCH_NOTIFICATION_REQUEST';
export const FETCH_NOTIFICATION_SUCCESS = 'FETCH_NOTIFICATION_SUCCESS';
export const UPDATE_LIST_NOTIFICATION = 'UPDATE_LIST_NOTIFICATION';
export const PUSH_LIST_NOTIFICATION = 'PUSH_LIST_NOTIFICATION';
export const TOGGLE_NOTIFICATION_REQUEST = 'TOGGLE_NOTIFICATION_REQUEST';
export const TOGGLE_NOTIFICATION_SUCCESS = 'TOGGLE_NOTIFICATION_SUCCESS';
export const TOGGLE_NOTIFICATION_FAILURE = 'TOGGLE_NOTIFICATION_FAILURE';

export const SET_NOTIFICATION_REQUEST = 'SET_NOTIFICATION_REQUEST';
export const SET_NOTIFICATION_SUCCESS = 'SET_NOTIFICATION_SUCCESS';
export const SET_NOTIFICATION_FAILURE = 'SET_NOTIFICATION_FAILURE';

export const FETCH_PRICE_NOTIFICATION_REQUEST = 'FETCH_PRICE_NOTIFICATION_REQUEST';
export const FETCH_PRICE_NOTIFICATION_SUCCESS = 'FETCH_PRICE_NOTIFICATION_SUCCESS';
export const FETCH_PRICE_NOTIFICATION_FAILURE = 'FETCH_PRICE_NOTIFICATION_FAILURE';